module.exports = __webpack_public_path__ + "static/img/uneven-01.6c27686.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/assessment/uneven-01.jpg
// module id = 296
// module chunks = 1